<template>
  <div>
    <data-table :service="ReferenceThirdPartiesService"
                service-method="getThirdParties"
                :service-params="serviceParams"
                :searchable="false"
                :columns="columns"
                :go-to-add-on-click="false"
                :go-to-details-on-row-click="false"
                :entity="entity"
                operations="refresh"
                ref="table">
      <template v-slot:value="{row}">
        <editable-grid-cell :value="row.value"
                            :showInput="true"
                            placeholder="Value"
                            @change="updateRowValue($event, row) ">
          {{ row.value }}
        </editable-grid-cell>
      </template>
    </data-table>
  </div>
</template>
<script>
import EditableGridCell from 'src/components/EditableGridCell'
import entities from 'src/config/entities'
import ReferenceThirdPartiesService from 'src/services/ReferenceThirdPartiesService'

export default {
  name: 'client-third-parties',
  components: {
    EditableGridCell,
  },
  data () {
    return {
      ReferenceThirdPartiesService,
      entity: entities.CLIENT_THIRD_PARTIES,
    }
  },
  computed: {
    domain() {
      const path = this.$route.fullPath
      if (path.includes('invoice')) {
        return 'invoice'
      }
      return 'client'
    },
    serviceParams () {
      return {
        referenceId: this.$route.params.id,
        domain: this.domain,
      }
    },
    columns () {
      return [
        {
          prop: 'name',
          label: this.$t('generic.name'),
          minWidth: '150px'
        },
        {
          prop: 'value',
          label: this.$t('generic.value'),
          minWidth: '150px'
        },
      ]
    },
  },
  methods: {
    async updateRowValue (evt, row) {
      let value = evt.target.value
      try {
        let data = {
          model: this.domain,
          model_id: this.$route.params.id,
          value
        }
        await ReferenceThirdPartiesService.updateThirdParty(row.id, data)
        this.$set(row, 'value', value)
        this.$notify({
          type: 'success',
          message: this.$t('third-parties.update.success')
        })
      } catch (err) {
        this.$notify({
          type: 'danger',
          message: this.$t('third-parties.update.error')
        })
      }
    },
  }
}
</script>
<style>
</style>
